import type {IGameLobbyPagePathPieces} from '~/pages/GameLobbyV2/types'
import type {IWaitingRoomPagePathPieces} from '~/pages/WaitingRoom/types'

export const dynamicURLs = {
  game: {
    waitingRoom: (pp: IWaitingRoomPagePathPieces | {maybeGameId: ':maybeGameId'}) =>
      `/game/${pp.maybeGameId}/waiting-room`,
    lobby: (pp: IGameLobbyPagePathPieces | {maybeGameId: ':maybeGameId'}) =>
      `/game/${pp.maybeGameId}/lobby`,
    lobbyV2: (pp: IGameLobbyPagePathPieces | {maybeGameId: ':maybeGameId'}) =>
      `/game/${pp.maybeGameId}/lobbyV2`,
  },
}

export const staticURLs = {
  home: '/',

  debugging: {
    metadataSHA: '/metadata/sha',
  },

  admin: {
    index: '/admin',
    signups: '/admin/sign-ups',
  },

  auth: {
    signin: '/sign-in',
    signout: '/sign-out',
    signup: '/sign-up',
  },

  dashboard: '/dashboard',
  settings: {
    index: '/settings',
  },
}
